<template>
	<div :class="['top-nav-box', { 'top-nav-box-shadow': shadow }]" style="background:#315491">
		<router-link class="left" to="/index">
			<img src="../assets/image/logo.png" alt="logo" />
		</router-link>
		<div class="main">
			<slot></slot>
		</div>
		<div class="right" v-if="hideLink">
			<router-link class="r-link nav-cart" to="/shoppingCart">
				<span>购物车</span>
				<div v-if='token && user.shoppingCartCount > 0' class="cart-number">{{ user.shoppingCartCount > 99 ? '99+' : user.shoppingCartCount  }}</div>
			</router-link>
			<router-link class="mail-box" to="/customer/account/mail">
				<img class="mail-img" src="../assets/image/mail.png" alt="">
				<div v-if='token && user.siteCount > 0' class="mail-num">{{ user.siteCount > 99 ? '99+' : user.siteCount  }}</div>
			</router-link>
			<template v-if="!token">
				<router-link class="r-link" to="/login">登录</router-link>
				<router-link class="r-link r-reg" to="/userReg">免费注册</router-link>
			</template>
			<template v-else>
				<div class="user-info flex-content" @click="toUser">
					<img class="u-icon" src="../assets/image/index-icon.png" alt="icon" srcset="" />
					<div class="name">{{ user.nick || user.mobile }}</div>
					<ul class="u-dropdown-menu">
						<li>
							<router-link to="/customer">我的主页</router-link>
						</li>
						<li>
							<span class="u-label">账户余额：</span><span class="price">{{ balance }}</span>
						</li>
						<li>
							<span class="u-label">冻结余额：</span><span class="price">{{ freezeAmount }}</span>
						</li>
						<li class="logout">
							<Button type="primary" @click="evt_logout">退出</Button>
						</li>
					</ul>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		name: "topNavMenu",
		data() {
			return {
				hideLink: true,
				shadow: true,
				bg: require("assets/image/nav-bg.png"),
			};
		},
		watch: {
			$route: {
				immediate: true,
				handler(val) {
					if (
						val.name === "login" ||
						val.name === "userReg" ||
						val.name === "forgetPassword"
					) {
						this.hideLink = false;
						this.shadow = false;
					}
				},
			},
		},
		computed: {
			...mapState(["user", "token", "freezeAmount", "balance"]),
		},
		methods: {
			...mapMutations(["MUT_TOKEN_INFO"]),
			evt_logout() {
				this.MUT_TOKEN_INFO({});
				window.location.reload();
				localStorage.removeItem("vuex");
			},
			toUser() {
				this.$router.push("/customer")
			}
		},
	};
</script>
<style lang="less" scoped>
	.top-nav-box-shadow {
		box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
		background-size: contain;
	}

	.top-nav-box {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		display: flex;
		// box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
		height: 90px;
		z-index: 1000;
		min-width: 1200px;

		.left {
			display: inline-block;
			font-size: 0;
			padding-left: 60px;
			align-self: center;

			img {
				height: 53px;
			}
		}

		.right {
			align-self: center;
			height: 100%;
			display: flex;
			margin-right: 20px;
			.nav-cart{
				position: relative;
				.cart-number{
					box-sizing: border-box;
					min-width: 18px;
					padding:0 5px;
					height: 18px;
					border-radius: 9px;
					color: #fff;
					font-size: 12px;
					background: #F9521f;
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					top:23px;
					right: 5px;
				}
				}
				.mail-box{
				position: relative;
				width: 48px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 20px;
				.mail-img{
					width: 24px;
					height: 24px;
				}
				.mail-num{
					box-sizing: border-box;
					min-width: 18px;
					padding:0 5px;
					height: 18px;
					border-radius: 9px;
					color: #fff;
					font-size: 12px;
					background: #F9521f;
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					top:23px;
					right: 0px;
				}
				}
			.r-link {
				display: inline-block;
				color: #fff;
				line-height: 90px;
				font-weight: 400;
				font-size: 14px;
				text-align: center;
				width: 80px;
			}

			.r-reg {
				// background-color: #3992e9;
				// width: 120px;
			}

			.user-info:hover .u-dropdown-menu {
				display: block;
			}

			.user-info {
				position: relative;
				cursor: pointer;

				.u-icon {
					width: 20px;
					height: 20px;
				}

				.name {
					position: relative;
					padding: 0 15px;
					color: #cacaff;
					font-size: 14px;
					font-weight: 400;
					width: 120px;
					text-overflow: ellipsis;
					overflow: hidden;
					cursor: pointer;

					&::after {
						content: "";
						display: inline-block;
						border: 7px solid;
						border-color: #cacaff transparent transparent transparent;
						vertical-align: middle;
						position: absolute;
						right: 0;
						top: 5px;
					}
				}

				.u-dropdown-menu {
					display: none;
					position: absolute;
					top: 100%;
					right: 0;
					z-index: 1000;
					min-width: 160px;
					padding: 5px 10px;
					list-style: none;
					font-size: 14px;
					text-align: left;
					background-color: #fff;
					border: 1px solid #ccc;
					border-radius: 4px;
					box-shadow: 0 4px 10px rgba(0, 0, 0, 0.18);
					background-clip: padding-box;

					li {
						line-height: 30px;
						display: flex;
						overflow: hidden;
						text-overflow: ellipsis;

						.u-label {
							flex: 0 0 70px;
						}

						.price {
							&::before {
								content: "¥";
								margin-right: 2px;
							}

							color: #ff5c35;
							text-overflow: ellipsis;
							overflow: hidden;
						}
					}

					.logout {
						margin-top: 10px;
					}
				}
			}
		}

		.main {
			flex: 1;
			padding: 0 96px;
			align-self: center;
		}
	}
</style>
